import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';

import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  put(arg0: string, arg1: {}) {
    throw new Error('Method not implemented.');
  }
  getStoreWiseSales(from: string, to: string) {
    throw new Error('Method not implemented.');
  }
  back() {
    throw new Error('Method not implemented.');
  }
//public ApiUrl="https://mrmobilechennaiapi.genuineitsolution.com/";  
public ApiUrl="https://happyherbsreportapi.genuineitsolution.com/";  
//  public ApiUrl = "https://localhost:44312/";
 public header: HttpHeaders;
public access_token="";
public token:string='';
public username:string='';
isload:boolean=false;
  public S_From_: any;
    File_Name = "Data";
  public Header_Disp = "";
public access_tocken = "";
  public add_item_name = "/add-items1";
  btndisable: boolean = false;
  public Company = "";
  public Branch = "0";
  public Division = "";
  public UserId = "0";
  public CREATED_BY = "";
  public Ref_ID = "0";
  public isadd = "0";
  public Edit_Row: any = {};
  public Edit_Row1: any = {};

  public Selected_Row: any = {};
  public Default_ref_ID: string = "Role";
  public URL_Location = "";

  public disp_category:boolean=false;
  public img_visible: boolean = false;
  public storeid:string="";
  public Date;
  public Date1;
  public From_Date;
  public To_Date;

  public User_Type = "Admin";
  public Document_Type = "Front_Banner";
  public Phone_Pattern = "^((\\+91-?)|0)?[0-9]{10}$";
  public Receipt_Print="false";

  public Side_Menu: boolean = false;
  public Today_Date = "";
  public S_From = "";
  public S_To = "";
  public FS_Date = "2021-04-01";

  public S_Bill_Type = "All";
  public S_Thari_Status = "All";
  public Calibration_Standard ="";
  public Category = "All";

  public S_Pay_Mode = "0";
  public S_Bill_Mode = "All";
  public S_Area = "All"
  public S_Sales_Order_by = "Bill_No";
  public S_Stock = "All"
  public S_Sales_Person = "All"
  public S_Type = "1"

  public Y_Date = "";
  public data: any = {};
  public Order_Status = "Pending";
  public Search_User = "All";
  public Approval_Status = "Pending";

  public Customer_Area = "All";
  public item_name_disp = "English";

  public T_Date = "";
  public T_Date_Time = "";

  public T_Status="A";

  public Pay_Date="";
  public exp_Date="";
  public Open_Customer_Total = 0;
  public Open_Customer_Length = 0;
  public DB_Expense_Total=0;
  public Receipt_Row_Total=0;
  public Emi_Loan_Issue_Total=0;
  public DB_Bank_Row=0;
  public DB_Bank_Total=0;

  public Item_Group="";
  Search_Branch: string;
    public Excel_Data: any = {
    'ID': '',
    "item": '',
    "Header": '',
    "Footer": '',
    "Left_Data": '',
    "Right_Data": '',
    "Report_Name": ''
  };
  headers;
  constructor(private toastr: ToastrService, public datePipe: DatePipe, public http: HttpClient, public router: Router, private _location: Location) {
    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    this.header = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    //this.S_From_ = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.S_From = this.datePipe.transform(new Date(), "yyyyMMdd");
    this.S_To = this.datePipe.transform(new Date(), "yyyyMMdd");

   }
   public tocken = "";
  get_Token() {
    this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.isload = true;
    this.http.post(this.ApiUrl + 'token', 'grant_type=password&UserName=admin&Password=admin', { headers: this.headers })
      .subscribe(
        (val) => {
          this.tocken = val['access_token'];
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });
    
  }

  getc(url) {
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.ApiUrl + "" + url + "?Company=" + this.Company, { headers: reqHeader });
  }

    getToken(username: string = 'admin', Password: string = 'admin'): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = `grant_type=password&UserName=${username}&Password=${Password}`;
    this.isload = true;

    return this.http.post<any>(`${this.ApiUrl}/token`, body, { headers })
      .pipe(
        map(response => {
          this.token = response.access_token;
          return this.token;
        }),
        catchError(error => {
          console.error('Token fetch error:', error);
          return throwError(() => new Error('Error fetching token'));
        })
      );
  }
post_data(data, Table) {
    
    data.Created_by = this.username;
    data.Table_Name = Table;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.isload = true;
    this.http.post(this.ApiUrl + 'api/Master/Post_Data', data, { headers })
      .subscribe(
        (val: string) => {
          this.isload = false;
          return val;
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

  
  }
  
  getTable(endpoint: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': `Bearer ${this.token}`
    });

    const url = `${this.ApiUrl}/${endpoint}`;

    return this.http.get<any>(url, { headers }).pipe(
      catchError(error => {
        console.error('Data fetch error:', error);
        return throwError(() => new Error('Error fetching table data'));
      })
    );}
    postTable(endpoint: string,payload: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.token}`
  });

  const url = `${this.ApiUrl}/${endpoint}`;

  return this.http.post<any>(url, payload,{ headers }).pipe(
    catchError(error => {
      console.error('Data post error:', error);
      return throwError(() => new Error('Error posting table data'));
    })
  );
}
export_excel() {
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });

    this.http.post(this.ApiUrl + 'api/master/JsontToExcel', this.Excel_Data, { headers: this.headers })
      .subscribe(
        (val: string) => {
          if (val == "True") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.ApiUrl + "Home/JsontToExcel?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');
          }
          else {
            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
        });
  }
   public SummaryReport_Row = [];
  get_SalesReport() {
  this.isload = true;
  this.get("Api/get_SalesReport1?From=" + this.S_From + "&To=" + this.S_To)
    .subscribe((res: any) => {   
      this.isload = false;
      this.SummaryReport_Row = JSON.parse(res).record;
    }); 
}


  
  get(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`
    });
    return this.http.get<any>(`${this.ApiUrl}/${url}`, { headers });
  }

  post(url: string, body: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.token}`
  });
  return this.http.post<any>(`${this.ApiUrl}/${url}`, body, { headers });
}


}
